import {useLocale} from "@components/Contexts/LocaleContext"
import Description from "@components/CustomTypography/Description/Description"
import {SeparatorType} from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {translate} from "@helpers/translate"
import {
	ContactUsCardDetails,
	ContactUsCardType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import styles from "./ContactUsCard.module.scss"

type Props = {
	data: ContactUsCardType
	container?: SeparatorType
	className?: string
	backgroundColor?: "#F8FAFE" | "white"
}

const ContactUsCard = (props: Props): JSX.Element => {
	const {locale} = useLocale()

	return (
		<div
			className={props.className}
			style={{backgroundColor: props.backgroundColor}}
		>
			<div className={styles.contactContent}>
				{(props.data.title || props.data.subtitle) && (
					<div>
						<Typography
							as={"p"}
							content={translate(props.data.title, locale)}
							size={Size.M}
							variant={Variant.Title}
						/>
						<Typography
							className={styles.countrySubtitle}
							content={props.data.subtitle}
							fontWeight={300}
							size={Size.S}
							variant={Variant.Title}
						/>
					</div>
				)}

				<div className={styles.cardDetails}>
					{props.data.cardDetails.map(
						(element: ContactUsCardDetails, index: number) => {
							return (
								<div
									key={index}
									className={styles.cardDetailsBox}
								>
									<div>
										<Typography
											content={element.name}
											fontWeight={700}
											size={Size.S}
											variant={Variant.Paragraph}
											noPadding
										/>
										<Typography
											content={element.position}
											size={Size.S}
											variant={Variant.Paragraph}
											noPadding
										/>
									</div>
									<div>
										<Description
											className={styles.tags}
											content={element.email}
											size={"S"}
											withoutPadding
										/>
										<Description
											content={element.phone}
											size={"S"}
											withoutPadding
										/>
									</div>
								</div>
							)
						},
					)}
				</div>
			</div>
		</div>
	)
}

export default ContactUsCard
